function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

var Emitter = require('component-emitter');
/**
 * Track completion of multiple assemblies.
 *
 * Emits 'assembly-complete' when an assembly completes.
 * Emits 'assembly-error' when an assembly fails.
 * Exposes a `.promise` property that resolves when all assemblies have
 * completed (or failed).
 */


var _assemblyIDs = /*#__PURE__*/_classPrivateFieldLooseKey("assemblyIDs");

var _reject = /*#__PURE__*/_classPrivateFieldLooseKey("reject");

var _remaining = /*#__PURE__*/_classPrivateFieldLooseKey("remaining");

var _resolve = /*#__PURE__*/_classPrivateFieldLooseKey("resolve");

var _uppy = /*#__PURE__*/_classPrivateFieldLooseKey("uppy");

var _watching = /*#__PURE__*/_classPrivateFieldLooseKey("watching");

var _onAssemblyComplete = /*#__PURE__*/_classPrivateFieldLooseKey("onAssemblyComplete");

var _onAssemblyCancel = /*#__PURE__*/_classPrivateFieldLooseKey("onAssemblyCancel");

var _onAssemblyError = /*#__PURE__*/_classPrivateFieldLooseKey("onAssemblyError");

var _onImportError = /*#__PURE__*/_classPrivateFieldLooseKey("onImportError");

var _checkAllComplete = /*#__PURE__*/_classPrivateFieldLooseKey("checkAllComplete");

var _removeListeners = /*#__PURE__*/_classPrivateFieldLooseKey("removeListeners");

var _addListeners = /*#__PURE__*/_classPrivateFieldLooseKey("addListeners");

var TransloaditAssemblyWatcher = /*#__PURE__*/function (_Emitter) {
  _inherits(TransloaditAssemblyWatcher, _Emitter);

  var _super = _createSuper(TransloaditAssemblyWatcher);

  function TransloaditAssemblyWatcher(uppy, assemblyIDs) {
    var _this;

    _classCallCheck(this, TransloaditAssemblyWatcher);

    _this = _super.call(this);
    Object.defineProperty(_assertThisInitialized(_this), _addListeners, {
      value: _addListeners2
    });
    Object.defineProperty(_assertThisInitialized(_this), _removeListeners, {
      value: _removeListeners2
    });
    Object.defineProperty(_assertThisInitialized(_this), _checkAllComplete, {
      value: _checkAllComplete2
    });
    Object.defineProperty(_assertThisInitialized(_this), _watching, {
      value: _watching2
    });
    Object.defineProperty(_assertThisInitialized(_this), _assemblyIDs, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), _reject, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), _remaining, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), _resolve, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), _uppy, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), _onAssemblyComplete, {
      writable: true,
      value: function value(assembly) {
        if (!_classPrivateFieldLooseBase(_assertThisInitialized(_this), _watching)[_watching](assembly.assembly_id)) {
          return;
        }

        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _uppy)[_uppy].log("[Transloadit] AssemblyWatcher: Got Assembly finish ".concat(assembly.assembly_id));

        _this.emit('assembly-complete', assembly.assembly_id);

        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _checkAllComplete)[_checkAllComplete]();
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), _onAssemblyCancel, {
      writable: true,
      value: function value(assembly) {
        if (!_classPrivateFieldLooseBase(_assertThisInitialized(_this), _watching)[_watching](assembly.assembly_id)) {
          return;
        }

        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _checkAllComplete)[_checkAllComplete]();
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), _onAssemblyError, {
      writable: true,
      value: function value(assembly, error) {
        if (!_classPrivateFieldLooseBase(_assertThisInitialized(_this), _watching)[_watching](assembly.assembly_id)) {
          return;
        }

        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _uppy)[_uppy].log("[Transloadit] AssemblyWatcher: Got Assembly error ".concat(assembly.assembly_id));

        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _uppy)[_uppy].log(error);

        _this.emit('assembly-error', assembly.assembly_id, error);

        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _checkAllComplete)[_checkAllComplete]();
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), _onImportError, {
      writable: true,
      value: function value(assembly, fileID, error) {
        if (!_classPrivateFieldLooseBase(_assertThisInitialized(_this), _watching)[_watching](assembly.assembly_id)) {
          return;
        } // Not sure if we should be doing something when it's just one file failing.
        // ATM, the only options are 1) ignoring or 2) failing the entire upload.
        // I think failing the upload is better than silently ignoring.
        // In the future we should maybe have a way to resolve uploads with some failures,
        // like returning an object with `{ successful, failed }` uploads.


        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _onAssemblyError)[_onAssemblyError](assembly, error);
      }
    });
    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _uppy)[_uppy] = uppy;
    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _assemblyIDs)[_assemblyIDs] = assemblyIDs;
    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _remaining)[_remaining] = assemblyIDs.length;
    _this.promise = new Promise(function (resolve, reject) {
      _classPrivateFieldLooseBase(_assertThisInitialized(_this), _resolve)[_resolve] = resolve;
      _classPrivateFieldLooseBase(_assertThisInitialized(_this), _reject)[_reject] = reject;
    });

    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _addListeners)[_addListeners]();

    return _this;
  }
  /**
   * Are we watching this assembly ID?
   */


  return TransloaditAssemblyWatcher;
}(Emitter);

function _watching2(id) {
  return _classPrivateFieldLooseBase(this, _assemblyIDs)[_assemblyIDs].indexOf(id) !== -1;
}

function _checkAllComplete2() {
  _classPrivateFieldLooseBase(this, _remaining)[_remaining] -= 1;

  if (_classPrivateFieldLooseBase(this, _remaining)[_remaining] === 0) {
    // We're done, these listeners can be removed
    _classPrivateFieldLooseBase(this, _removeListeners)[_removeListeners]();

    _classPrivateFieldLooseBase(this, _resolve)[_resolve]();
  }
}

function _removeListeners2() {
  _classPrivateFieldLooseBase(this, _uppy)[_uppy].off('transloadit:complete', _classPrivateFieldLooseBase(this, _onAssemblyComplete)[_onAssemblyComplete]);

  _classPrivateFieldLooseBase(this, _uppy)[_uppy].off('transloadit:assembly-cancel', _classPrivateFieldLooseBase(this, _onAssemblyCancel)[_onAssemblyCancel]);

  _classPrivateFieldLooseBase(this, _uppy)[_uppy].off('transloadit:assembly-error', _classPrivateFieldLooseBase(this, _onAssemblyError)[_onAssemblyError]);

  _classPrivateFieldLooseBase(this, _uppy)[_uppy].off('transloadit:import-error', _classPrivateFieldLooseBase(this, _onImportError)[_onImportError]);
}

function _addListeners2() {
  _classPrivateFieldLooseBase(this, _uppy)[_uppy].on('transloadit:complete', _classPrivateFieldLooseBase(this, _onAssemblyComplete)[_onAssemblyComplete]);

  _classPrivateFieldLooseBase(this, _uppy)[_uppy].on('transloadit:assembly-cancel', _classPrivateFieldLooseBase(this, _onAssemblyCancel)[_onAssemblyCancel]);

  _classPrivateFieldLooseBase(this, _uppy)[_uppy].on('transloadit:assembly-error', _classPrivateFieldLooseBase(this, _onAssemblyError)[_onAssemblyError]);

  _classPrivateFieldLooseBase(this, _uppy)[_uppy].on('transloadit:import-error', _classPrivateFieldLooseBase(this, _onImportError)[_onImportError]);
}

module.exports = TransloaditAssemblyWatcher;